import React from 'react';
import { Button, ButtonStyleProps, useButtonStyles } from '@modernhealth/vital-components';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

export type InternalLinkButtonProps = Omit<LinkProps, keyof ButtonStyleProps> & ButtonStyleProps;

export const InternalLinkButton = React.forwardRef<HTMLAnchorElement, InternalLinkButtonProps>(
    (props, ref) => {
        const {
            children,
            className,
            variant,
            size = 'medium',
            rounded,
            fluid,
            disabled,
            icon,
            iconAlign,
            to,
            ...linkProps
        } = props;

        const buttonStyles = useButtonStyles({
            className,
            variant,
            size,
            rounded,
            fluid,
            disabled,
            icon,
            iconAlign,
        });

        /**Return a button with disabled style since this component is a the end an <a> tag */
        if (disabled)
            return <Button children={children} className={buttonStyles} disabled={disabled} />;

        return (
            <RouterLink innerRef={ref} to={to} className={buttonStyles} {...linkProps}>
                {children}
            </RouterLink>
        );
    },
);
